<template>
  <div class="fieldSet">

    <div class="topTitle">
      <span class="title">人员档案字段设置</span>
      <div class="operate">
        <el-button size="small" type="primary" @click="operateGroup()">新建分组</el-button>
        <el-button size="small" type="primary" @click="groupSortShow()">分组排序</el-button>
      </div>
    </div>

    <div class="infoBoxs">
      <!-- 一个分组 -->
      <div class="infoBox" v-for="(item,index) in allGroupData" :key="index">
        <div class="title" @click="item.isOpen = !item.isOpen">
          <div class="left">
            <span>{{item.name}}</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <div class="right">
            <el-button size="small" v-if="item.isSysGroup == 'N'" type="info" icon="el-icon-delete" @click.stop="deleteGroup(item)">删除分组</el-button>
            <el-button size="small" type="info" icon="el-icon-edit" @click.stop="operateGroup(item)">重命名分组</el-button>
            <!-- <el-button size="small" type="info" icon="el-icon-circle-plus-outline" @click.stop="addField(item,'add')">新增字段</el-button> -->
            <el-button size="small" type="info" icon="el-icon-sort" @click.stop="item.showFieldSort = !item.showFieldSort">字段排序</el-button>
          </div>
        </div>
        <div class="tableCon" v-if="item.isOpen">
          <el-table :data="item.tableData" highlight-current-row style="width: 100%">
            <el-table-column header-align="center" align="center" prop="fieldDesc" label="序号">
              <template slot-scope="scope">
              {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column header-align="center" align="center" prop="fieldDesc" label="字段名称">
            </el-table-column>
            <el-table-column header-align="center" align="center" prop="fieldType" label="字段类型">
              <template slot-scope="scope">
                {{scope.row.fieldType | filterFiledType}}
              </template>
            </el-table-column>
            <el-table-column header-align="center" align="center" prop="isRequired" label="是否必填">
              <template slot-scope="scope">
                {{scope.row.isRequired=='Y'?'是':'否'}}
              </template>
            </el-table-column>
            <el-table-column header-align="center" align="center" prop="isSysField" label="是否系统字段">
              <template slot-scope="scope">
                {{scope.row.isSysField=='Y'?'是':'否'}}
              </template>
            </el-table-column>
            <el-table-column header-align="center" align="center" label="操作" width="170">
              <template slot-scope="scope">
                <div class="opreateIcon" v-if="item.showFieldSort">
                  <i v-if="scope.$index+1 != item.tableData.length" class="el-icon-sort-down" @click="sortDownField(item.tableData,scope.row,scope.$index)"></i>
                  <i v-if="scope.$index !=0" class="el-icon-sort-up" @click="sortUpField(item.tableData,scope.row,scope.$index)"></i>
                </div>
                <span class="operateBtn" @click="addField(scope.row,'see')">查看</span>
                <span class="operateBtn" @click="addField(scope.row,'edit')"> | 编辑</span>
                <span v-if="scope.row.isSysField == 'N' && item.isSysGroup == 'N'" class="operateBtn" @click="deleteField(scope.row)" style="margin-left:20px;">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 结束 -->
    </div>

    <!-- 新增分组弹窗 -->
    <el-dialog :title="addGroupForm.guid?'编辑分组':'新建分组'" :visible.sync="showAddGroup" width="560px" class="addGroupClass">
      <el-form :model="addGroupForm" :rules="addGroupRules" ref="addGroupForm" label-width="100px">
        <el-form-item label="分组名称" prop="name">
          <el-input v-model="addGroupForm.name" autocomplete="off" placeholder="请输入分组名称"></el-input>
        </el-form-item>
        <el-form-item label="是否系统分组" prop="isSysGroup" v-if="!addGroupForm.guid">
          <el-select v-model="addGroupForm.isSysGroup" filterable placeholder="请选择系统分组" style="width:100%;">
            <el-option label="是" value="Y"></el-option>
            <el-option label="否" value="N"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAddGroup = false" size="small">取 消</el-button>
        <el-button type="primary" @click="addFiledGroup('addGroupForm')" size="small">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 结束 -->

    <!-- 分组排序弹窗-->
    <el-dialog title="分组排序" :visible.sync="showGroupSort" width="560px" @close="confirmGroupSort">
      <el-table :data="groupTableData" v-loading="groupSortLoading" highlight-current-row row-key="id" ref="groupSortTable" style="width: 100%">
        <el-table-column prop="name" label="分组名称">
        </el-table-column>
        <el-table-column label="操作" width="110">
          <template slot-scope="scope">
            <div class="opreateIcon" v-if="scope.$index >1">
              <i v-if="scope.$index+1 != groupTableData.length" class="el-icon-sort-down" @click="sortDownGroup(scope.row,scope.$index)"></i>
              <i v-if="scope.$index !=0 && scope.$index !=2" class="el-icon-sort-up" @click="sortUpGroup(scope.row,scope.$index)"></i>
            </div>
            <div v-else style="color:#999;"> 系统字段 </div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="confirmGroupSort" size="small">取 消</el-button> -->
        <el-button type="primary" @click="confirmGroupSort" size="small">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 结束 -->

    <!-- 新增编辑字段侧拉 -->
    <el-drawer :visible.sync="showAddField" :with-header="false">
      <div class="drawerBox">
        <div class="title">
          <p class="line1">{{editState=='Y'?'编辑字段':editState!=='Y'&&!addFieldForm.guid?'新增字段':'查看字段'}}</p>
          <p class="line2">系统字段部分不可编辑</p>
        </div>
        <div class="formBox">
          <el-form :model="addFieldForm" :rules="addFieldRules" ref="addFieldForm" label-width="110px">
            <el-form-item label="所在分组：" prop="groupGuid">
              <!-- <el-input v-model="addFieldForm.groupName" disabled autocomplete="off" clearable placeholder="请选择所在分组"></el-input>groupTableData -->
              <el-select v-model="addFieldForm.groupGuid" :disabled="editState == 'Y'?false:true" placeholder="请选择所在分组" @change="groupChange"  ref="select">
                <el-option v-for="(item,index) in allGroupData" :key="index" :label="item.name" :value="item.guid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="字段名称：" prop="fieldDesc">
              <el-input v-model="addFieldForm.fieldDesc" :disabled="editState == 'Y'?false:true" autocomplete="off" clearable placeholder="请输入字段名称" width="240px"></el-input>
            </el-form-item>
            <el-form-item label="字段编码：" prop="fieldName">
              <el-input v-model="addFieldForm.fieldName" disabled autocomplete="off" clearable placeholder="请输入字段编码" width="240px"></el-input>
            </el-form-item>
            <el-form-item label="字段类型：" prop="fieldType">
              <el-select v-model="addFieldForm.fieldType" disabled filterable placeholder="请选择字段类型">
                <el-option v-for="(item,index) in allfiledTypeOption" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="addFieldForm.fieldType == 'dropdownlist' || addFieldForm.fieldType =='dropdown'" label="选项内容：" prop="dataSource">
              <span v-for="(o,index) in addFieldForm.dataSource" :key="index" style="margin-right:16px;">{{o.name}}</span>
            </el-form-item>
            <el-form-item label="提示文字：" prop="tipText">
              <el-input v-model="addFieldForm.tipText" :disabled="editState == 'Y'?false:true" autocomplete="off" clearable placeholder="请输入提示文字"></el-input>
            </el-form-item>
            <el-form-item label="宽度：" prop="tipText">
              <el-input v-model="addFieldForm.width" :disabled="editState == 'Y'?false:true" autocomplete="off" clearable placeholder="请输入宽度"></el-input>
            </el-form-item>
            <el-form-item label="是否必填：" prop="isRequired">
              <el-radio-group v-model="addFieldForm.isRequired" :disabled="editState == 'Y'?false:true">
                <el-radio label="Y">必填</el-radio>
                <el-radio label="N">非必填</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
        <!-- <div class="resultBox">
          <p class="line">结果预览</p>
        </div> -->
        <div class="operateBox" v-if="editState == 'Y'">
          <el-button @click="showAddField = false" size="small">取 消</el-button>
          <el-button type="primary" @click="submitFieldForm('addFieldForm')" size="small">确 定</el-button>
        </div>
      </div>
    </el-drawer>
    <!-- 结束 -->

  </div>
</template>
<script>
export default {
  name:'personnelFieldSet',
  data() {
    return {
        allGroupData:[], //所有分组数据
        allFiledData:[], //所有字段数据
        // 新增编辑分组
        showAddGroup:false,
        addGroupForm:{
          tenantGuid: "",
          name: "",
          groupType: "ROSTER",  //ROSTER 为花名册
          orderNum: 99,
          isSysGroup: "N"
        },
        addGroupRules:{
            name:[{ required: true, message: '请输入分组名称', trigger: 'blur' }]
        },
        //分组排序
        showGroupSort:false,
        groupSortLoading:false,
        groupTableData:[],
        //新增编辑字段
        showAddField:false,
        addFieldForm:{
          groupGuid: "",
          groupName: "",
          fieldName: "",
          fieldType: "",
          fieldDesc: "",
          fieldValue: "",
          isSysField: "N",
          isRequired: "N",
          tipText: "",
          formVisible: "Y",
          formOrderNum: 99,
          listVisible: "Y",
          listOrderNum: 99,
          width:null
        },
        addFieldRules:{
          groupName:[{ required: true, message: '请选择分组名称', trigger: 'blur' }],
          fieldDesc:[{ required: true, message: '请输入字段名称', trigger: 'blur' }],
          fieldName:[{ required: true, message: '请输入字段编码', trigger: 'blur' }],
          fieldType:[{ required: true, message: '请选择字段类型', trigger: 'blur' }],
          isRequired:[{ required: true, message: '请选择是否必填', trigger: 'blur' }],
        },
        allfiledTypeOption:[  //字段类型下拉
          {
            label:'文本',
            value:'input'
          },{
            label:'多行文本',
            value:'text'
          },{
            label:'单选',
            value:'dropdown'
          },{
            label:'多选',
            value:'dropdownlist'
          },{
            label:'日期',
            value:'date'
          },{
            label:'文件',
            value:'file'
          },
          {
            label:'图片',
            value:'img'
          },
          {
            label:'省市区',
            value:'areaselect'
          }
        ],
        showFieldSort:false,
        editState:'N'//判断是否编辑
    };
  },
  created() {
  },
  mounted(){
      this.getGroupList()
  },
  filters:{
    filterFiledType(type) {
        let str = null
        switch(type){
          case 'input':
            str = '文本';
            break;
          case 'text':
            str = '多行文本';
            break;
          case 'dropdown':
            str = '单选';
            break;
          case 'dropdownlist':
            str = '多选';
            break;
          case 'date':
            str = '日期';
            break;
          case 'file':
            str = '文件';
            break;
          case 'areaselect':
            str ='省市区';
            break;
        }
      return str
    },
  },
  methods: {
    // visibleChange(flag) {
    //   if (flag) {
    //     this.$refs.select.blur()
    //   } else {
    //     this.$refs.select.focus()
    //   }
    // },
    //删除字段
    deleteField(item){
      let guids = [item.guid]
      this.api.postJson(`/${serverConfig.msConfigureService}/cfg/field/del`, guids).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message.success("删除成功");
          this.getGroupList(); 
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 提交字段新增、编辑
    submitFieldForm(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.addFieldForm.guid){
            this.api.put(`/${serverConfig.msConfigureService}/cfg/field/update`,this.addFieldForm).then(res => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                this.showAddField = false
                this.$message.success('修改成功!')
                this.getGroupList()
              } else {
                this.$message.error(res.data.msg);
              }
            });
          }else{ 
            this.api.postJson(`/${serverConfig.msConfigureService}/cfg/field/add`,this.addFieldForm).then(res => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                this.showAddField = false
                this.$message.success('添加成功!')
                this.getGroupList()
              } else {
                this.$message.error(res.data.msg);
              }
            });
          }
        }
      });
    },
    //新增或编辑字段
    addField(item,type){
      if(type =='add'){
        this.addFieldForm ={
          groupGuid:item.guid,
          groupName:item.name,
          fieldName: "",
          fieldType: "",
          fieldDesc: "",
          fieldValue: "",
          isSysField: "N",
          isRequired: "N",
          tipText: "",
          formVisible: "Y",
          formOrderNum: 0,
          listVisible: "Y",
          listOrderNum: 0
        }
      }else{
        this.addFieldForm = JSON.parse(JSON.stringify(item))
        this.addFieldForm.dataSource = this.addFieldForm.dataSource?JSON.parse(this.addFieldForm.dataSource):[]
      }
      if(type == 'edit'){
        this.editState = 'Y'
      }else{
        this.editState = 'N'
      }
      this.showAddField = true
    },
    //添加、修改分组
    addFiledGroup(formName){ 
      this.addGroupForm.tenantGuid = this.$store.state.guid
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.addGroupForm.guid){
            this.api.put(`/${serverConfig.msConfigureService}/cfg/group/update`,this.addGroupForm).then(res => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                this.showAddGroup = false
                this.$message.success('修改成功!')
                this.getGroupList()
              } else {
                this.$message.error(res.data.msg);
              }
            });
          }else{ 
            this.api.postJson(`/${serverConfig.msConfigureService}/cfg/group/add`,this.addGroupForm).then(res => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                this.showAddGroup = false
                this.$message.success('添加成功!')
                this.getGroupList()
              } else {
                this.$message.error(res.data.msg);
              }
            });
          }
        }
      });
    },
    //操作分组
    operateGroup(pObject){
      let obj = {
        tenantGuid: "",
          name: "",
          groupType: "ROSTER",  //ROSTER 为花名册
          orderNum: 0,
          isSysGroup: "N"
      }
      this.addGroupForm = pObject?JSON.parse(JSON.stringify(pObject)):obj
      this.showAddGroup = true
    },
    //删除分组
    deleteGroup(item){
      let guids = [item.guid]
      this.api.postJson(`/${serverConfig.msConfigureService}/cfg/group/del`, guids).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message.success("删除成功");
          this.getGroupList(); 
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //获取分组列表
    getGroupList(type){
      let params = {
        pageSize:100,
        pageIndex:1,
        groupName:'',
        tenantGuid:this.$store.state.guid,
      }
      this.api.get(`/${serverConfig.msConfigureService}/cfg/group/list`,params).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = res.data.data.records?res.data.data.records:[]
          data.forEach((item,index) => {
            item.showFieldSort = false
            if(index == 0){
              item.isOpen = true
            }else{
              item.isOpen = false
            }
          });
          this.allGroupData = data
          this.getFieldList()
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    groupChange(val){
      this.allGroupData.forEach(i=>{
        if(val == i.guid){
          this.addFieldForm.groupName = i.groupName;
        }
      })
    },
    //获取字段列表
    getFieldList(){
      let params = {
        pageSize:500,
        pageIndex:1,
        tenantGuid:this.$store.state.guid,// '3d3861e610cb40218d3ecf641147affd',
        chineseName:'',
        fieldType:''
      } 
      this.api.get(`/${serverConfig.msConfigureService}/cfg/field/list`,params).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.allFiledData = res.data.data.records?res.data.data.records:[]
          this.allGroupData.forEach(item=>{
            let tableData = []
            this.allFiledData.forEach(oneData=>{
              if(oneData.groupGuid == item.guid){
                tableData.push(oneData)
              }
            })
            tableData.sort((a,b)=>{return a.formOrderNum - b.formOrderNum})
            this.$set(item,'tableData',tableData)
          })
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //分组排序
    groupSortShow(){
      this.groupTableData = JSON.parse(JSON.stringify(this.allGroupData))
      this.showGroupSort = true
    },
    // 确定分组排序
    confirmGroupSort(){
      this.showGroupSort = false
      this.getGroupList()
    },
    //分组排序-向下
    sortDownGroup(row,index){
      let changeLine = this.groupTableData[index+1]
      let orderNumFlag = row.orderNum
      row.orderNum = changeLine.orderNum
      changeLine.orderNum = orderNumFlag
      this.groupTableData.splice(index,1)
      this.groupTableData.splice(index+1,0,row)
      this.updateGroupSort(row,changeLine)
    },
    //分组排序-向上
    sortUpGroup(row,index){
      let changeLine = this.groupTableData[index-1]
      let orderNumFlag = row.orderNum
      row.orderNum = changeLine.orderNum
      changeLine.orderNum = orderNumFlag
      this.groupTableData.splice(index,1)
      this.groupTableData.splice(index-1,0,row)
      this.updateGroupSort(row,changeLine)
    },
    //更新分组排序
    updateGroupSort(dragLine,currentLine){
       let that = this
       that.groupSortLoading = true
       let newPromise = new Promise(function(resolve,reject){
          that.api.put(`/${serverConfig.msConfigureService}/cfg/group/update`,dragLine).then(res => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                resolve()
              } else {
                that.$message.error(res.data.msg);
              }
              that.groupSortLoading = false
            });
        })
        newPromise.then(function(){
          that.api.put(`/${serverConfig.msConfigureService}/cfg/group/update`,currentLine).then(res => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              } else {
                that.$message.error(res.data.msg);
              }
              that.groupSortLoading = false
            });
        })
    },
     //字段排序-向下
    sortDownField(data,row,index){
      let changeLine = data[index+1]
      let orderNumFlag = row.formOrderNum
      row.formOrderNum = changeLine.formOrderNum
      changeLine.formOrderNum = orderNumFlag
      data.splice(index,1)
      data.splice(index+1,0,row)
      this.updateFieldSort(row,changeLine)
    },
    //字段排序-向上
    sortUpField(data,row,index){
      let changeLine = data[index-1]
      let orderNumFlag = row.formOrderNum
      row.formOrderNum = changeLine.formOrderNum
      changeLine.formOrderNum = orderNumFlag
      data.splice(index,1)
      data.splice(index-1,0,row)
      this. updateFieldSort(row,changeLine)
    },
    //更新字段排序
    updateFieldSort(dragField, currentField) {
      let that = this
      dragField.dataSource = dragField.dataSource ? JSON.parse(dragField.dataSource) : [];
      currentField.dataSource = currentField.dataSource ? JSON.parse(currentField.dataSource) : [];
      let newPromise = new Promise(function (resolve, reject) {
        that.api.put(`/${serverConfig.msConfigureService}/cfg/field/update`, dragField).then(res => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            resolve()
          } else {
            that.$message.error(res.data.msg);
          }
        });
      })
      newPromise.then(function () {
        that.api.put(`/${serverConfig.msConfigureService}/cfg/field/update`, currentField).then(res => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          } else {
            that.$message.error(res.data.msg);
          }
        });
      })
    },
  },
};
</script> 
<style scoped>
.fieldSet .el-button--primary {
    color: #FFF;
    background-color: #4fa1a4;
    border-color: #4fa1a4;
}
.fieldSet .el-button--info{
    color: #323233;
    background: #F7F8FA;
    border: none;
    font-size: 14px;
}
.topTitle{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
}
.topTitle .title{
    font-size: 18px;
    color: #323233;
}
/* 字段表格 */
.infoBoxs{
    padding: 0 14px 14px 14px;
}
.infoBoxs .infoBox{
    background: #FFF;
    padding: 20px 26px;
    margin-bottom: 16px;
}
.infoBoxs .infoBox .title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}
.infoBox .title .left{
  cursor: pointer;
}
.infoBox .title .left span{
    font-size: 16px;
    margin-right: 14px;
}
.infoBox .title .left i{
    font-size: 16px;
}
.infoBox .tableCon{
    padding-top: 20px;
}
.infoBox .tableCon .operateBtn{
    color: #649FA4;
    font-size: 14px;
    cursor: pointer;
}
/* 新增编辑分组 */
/* .addGroupClass .el-form-item{
    margin: 0;
} */
/* 新增编辑字段 */
.drawerBox{
  /* background: #F7F8FA; */
  min-height: 100vh;
}
.drawerBox .title{
  padding: 24px;
  text-align: left;
  line-height: 30px;
  margin-bottom: 12px;
  background: #fff;
}
.drawerBox .title .line1{
  font-size: 16px;
  margin: 0;
  color: #323233;
}
.drawerBox .title .line2{
  font-size: 14px;
  margin: 0;
  color: #909399;
}
.drawerBox .formBox{
  padding: 24px;
  margin-bottom: 12px;
  background: #fff;
  text-align: left;
}
.drawerBox .formBox .el-input,.drawerBox .formBox .el-select{
  width: 240px;
}
.drawerBox .resultBox{
  padding: 24px;
  text-align: left;
  background: #fff;
}
.drawerBox .resultBox .line{
  font-size: 14px;
  margin: 0;
  color: #323233;
}
.drawerBox .operateBox{
  text-align: left;
  margin-top: 10vh;
  margin-left: 30px;
}
.drawerBox .operateBox .el-button{
  font-size: 14px;
  padding: 9px 50px;
}
.opreateIcon{
  display:inline-block;
  width: 80px;
  text-align: left;
}
.opreateIcon i{
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  padding:2px 6px;
  margin-left: 4px;
}
.opreateIcon i:hover{
  color: #4fa1a4;
}
</style>